import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1f8f1e50"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "screen-wrapper" }

import { watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'

import IconButton from '@/popup/components/shared/IconButton.vue'
import { PopupDatabase } from '@/popup/storage/Database'
import { useGlobals } from '@/popup/compositions/useGlobals'
import { InternalAPI, InternalMethods } from '@/shared/apis/messages'
import { useAppStore } from '@/popup/store/AppStore'
import { useApprovalsStore } from '@/popup/store/ApprovalsStore'
import { redirectAfterApproval } from '@/popup/utils/redirectAfterApproval'
import { useUIStore } from '@/popup/store/UIStore'
import NetworkSwitchWrapper from '@/popup/components/shared/NetworkSwitchWrapper.vue'
import AppIdenticon from '@/popup/components/shared/AppIdenticon/AppIdenticon.vue'
import { t } from '@/popup/lib/i18n'
import { DBNotifications } from '@/shared/apis/bgnotifications'
import { ToastType } from '@/shared/models/AppNotification'
import { useNotifications } from '@/popup/compositions/useNotifications'
import getUniqueId from '@/shared/getUniqueId'


export default /*#__PURE__*/_defineComponent({
  __name: 'ImportFrame',
  setup(__props) {

const router = useRouter()
const route = useRoute()
const appStore = useAppStore()

const switchToPreviousProfile = async () => {
  let previousProfile = await PopupDatabase.getPreviousProfile()
  if (!previousProfile) {
    const [profile] = await PopupDatabase.getPopupProfiles()
    previousProfile = profile?.address
  }
  const data = await useGlobals().sendMessage({
    method: InternalMethods.SWITCH_PROFILE,
    payload: { address: previousProfile },
  })
  await useAppStore().handleUserChange(data)

  return previousProfile
}

const onImportCancel = async (routeTo?: string) => {
  const currentRoute = router.currentRoute.value
  const id = currentRoute.params['id']

  if (id && currentRoute.path.startsWith('/qrcode/import-profile-dapp/')) {
    const importRequestId = id.toString()
    //This method fires when a user cancels an import originated from
    //the dApp. Once we are on the 'waiting' screen, the approval
    //has already been resolved and this method is no longer called.
    await onApprovalCancel(importRequestId)
    return
  }
  try {
    const address = router.currentRoute.value.query['address'] as string
    if (!address) {
      //This means we canceled when we were on the import profile screen
      //The profile was not saved in the storage at that point
      return
    }

    //This means we canceled the import on the 'waiting' screen or 'importRequestAccess' screen
    //The profile was switched and saved in the storage, need to cleanup and revert
    await switchToPreviousProfile()
    useNotifications().updateToast({
      id: getUniqueId(),
      method: DBNotifications.NOTIFICATION,
      profileAddress: '',
      message: t('import_profile.cancelled'),
      type: ToastType.ERROR,
      system: false,
      isPersistent: false,
    })

    await useGlobals().sendMessage({
      method: InternalMethods.CANCEL_IMPORT_PROFILE,
      payload: { address },
    })
  } finally {
    if (useUIStore().isPopup) {
      window.close()
    } else {
      router.push(routeTo || '/home')
    }
  }
}

const onApprovalCancel = async (approvalId: string, errorMessage?: string) => {
  const directive = await useGlobals().sendMessage({
    method: InternalMethods.HANDLE_APPROVAL,
    payload: {
      requestId: approvalId,
      action: 'REJECTED',
      data: {
        errorMessage,
      },
    } as InternalAPI[InternalMethods.HANDLE_APPROVAL]['payload'],
  })
  const approvalsStore = useApprovalsStore()
  approvalsStore.processDirective(directive)

  redirectAfterApproval(
    router,
    approvalsStore.nonStashedApprovals.length,
    useAppStore().lastPopupState?.path
  )
}

watch(
  () => appStore.currentProfile.importStatus,
  async importStatus => {
    if (importStatus === 'imported') {
      await router.push('/')
    }
  }
)

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(AppIdenticon),
      (_unref(route).path !== '/qrcode')
        ? (_openBlock(), _createBlock(IconButton, {
            key: 0,
            onOnClick: onImportCancel,
            class: "mt-5"
          }))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", null, [
        _createVNode(_component_router_view, {
          onImportCancel: onImportCancel,
          onImportApprovalCancel: onApprovalCancel
        })
      ])
    ]),
    _createVNode(NetworkSwitchWrapper)
  ], 64 /* STABLE_FRAGMENT */))
}
}

})